/** Retire unsupported listing tabs without leaving an invisible filter active. */
export function normalizeListingSearchParams(params: URLSearchParams): URLSearchParams {
  const listingType = params.get("listingType");
  if (listingType === null || listingType === "sale" || listingType === "rent") {
    return params;
  }

  const next = new URLSearchParams(params);
  next.set("listingType", "sale");
  next.delete("page");
  next.delete("handoverFrom");
  next.delete("handoverTo");
  return next;
}
